//Please add the language resource
const toxinExemptSetting = {
  plantName:'基地名称',
  plantCode:'基地',
  supplierCode:'供应商',
  supplierName:'供应商名称',
  provinceName:"省",
  cityName:"市",
  countyName:'区',
  townName:'镇',
  exemptionRatio:'免检比例%',
  creator: '创建者',
  createTime: '创建时间',
  updater: '更新者',
  updateTime: '更新时间',
  msg:{
  }
};
export default toxinExemptSetting



// WEBPACK FOOTER //
// ./src/page/toxin/toxinExemptSetting/lang/toxinExemptSetting.en.js